import { InfoCard, StructuredMetadataTable, WarningPanel } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { buildMetadata, formatDate, sandboxAnnotation } from './annotations';

const APPROVAL_LABELS: Record<string, string> = {
  pending: 'Pending approval',
  denied: 'Denied',
  approved: 'Approved',
};

export function LeaseDetailsCard() {
  const { entity } = useEntity();
  const approval = sandboxAnnotation(entity, 'approval-status');
  const metadata = buildMetadata(entity, [
    { label: 'Approval', key: 'approval-status', format: v => APPROVAL_LABELS[v] ?? v },
    { label: 'Status', key: 'status' },
    { label: 'Active', key: 'is-active' },
    { label: 'AWS Account ID', key: 'aws-account-id', format: v => (v === 'unknown' ? 'Not assigned yet' : v) },
    { label: 'Template', key: 'template-name' },
    { label: 'Duration (hours)', key: 'duration-hours' },
    { label: 'Max Spend', key: 'max-spend' },
    { label: 'Expires', key: 'expiration-date', format: formatDate },
    { label: 'Created', key: 'created-at', format: formatDate },
    { label: 'Owner', key: 'user-name' },
    { label: 'Owner Email', key: 'user-email' },
  ]);

  return (
    <InfoCard title="Lease Details">
      {approval === 'pending' && (
        <WarningPanel
          severity="info"
          title="Pending approval"
          message="This lease's template requires approval by a platform admin. No AWS account is assigned yet: your Space's GitLab group and repos exist, but you won't be added to them and their pipelines can't deploy until the lease is approved. This page updates within a few minutes of approval."
        />
      )}
      {approval === 'denied' && (
        <WarningPanel
          severity="error"
          title="Lease request denied"
          message="A platform admin denied this lease request. Its GitLab group and repos are removed automatically."
        />
      )}
      <StructuredMetadataTable metadata={metadata} />
    </InfoCard>
  );
}
